module.exports = __webpack_public_path__ + "integration-be-logo.png?68b6558254d861eb657b23019564f9fb";